// Backend API types for session-scoped admin course access.
// Routes (edrna_backend/application/routes.py):
//   GET  /administration/admin-course/enter/{course_id}  (administration:admin_course:enter)
//   POST /administration/admin-course/quit               (administration:admin_course:quit)
// Delivered to the FE on the `admin_course` key of `sayhi`.
export type AdminCourseSession = {
  admin_user_id: string;
  /** the courses entered; nothing is inherited, so this is the whole scope */
  course_ids: string[];
};

export function inAdminCourseScope(
  courseId: string | undefined,
  scope: AdminCourseSession | null | undefined,
): boolean {
  if (!courseId || !scope) return false;
  return (scope.course_ids || []).includes(courseId);
}
